module.exports = __webpack_public_path__ + "static/img/1.63e8935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/1.png
// module id = 2cR2
// module chunks = 31